import { makeChanged } from '@/components/profile';

/**
 * Request body for saving from the company profile: only the top-level keys
 * that changed. The server fills the rest of a settings group in from what is
 * stored (preserveUnsentCompanyFields), so a partial body loses nothing, and a
 * save without changes is not sent at all.
 *
 * @param {Object} params
 * @param {Object} params.payload - what the classic form would send
 * @param {Object} params.current - form.getFieldsValue(true)
 * @param {Object} params.base - form values as loaded
 * @returns {{ body: Object, hasChanges: boolean }}
 */
export default function buildCompanyProfileBody({ payload, current, base }) {
  const changed = makeChanged(current, base);
  const body = Object.fromEntries(
    Object.entries(payload).filter(([key]) => changed(key))
  );
  return { body, hasChanges: Object.keys(body).length > 0 };
}
